import { Component } from '@angular/core';
import { environment } from '@env/environment';

enum LAYOUT_STYLE {
  SIDE_BAR = 'sidebar',
  NEST = 'nest',
  TOP = 'top'
}

@Component({
  selector: 'layout-default',
  template: `
    <ng-container [ngSwitch]="layoutStyle">
      <layout-nest *ngSwitchCase="LAYOUT_STYLE.NEST"></layout-nest>
      <layout-top *ngSwitchCase="LAYOUT_STYLE.TOP"></layout-top>
      <layout-sidebar *ngSwitchDefault></layout-sidebar>
    </ng-container>
  `,
  styles: []
})
export class LayoutDefaultComponent {
  readonly LAYOUT_STYLE = LAYOUT_STYLE;

  layoutStyle = environment.LAYOUT_STYLE;

  constructor() {}
}
